import DayHeader from './DayHeader.view';

export default DayHeader;
